<script setup lang="ts">
import BaseComparisonTable from '@/components/ui/comparison/BaseComparisonTable.vue'
import type { PageContent } from '@/assets/ts/pages/shipment-protection-shipping'

const props = defineProps<{
	pageContent: PageContent
}>()
</script>

<template>
	<BaseComparisonTable :page-content="pageContent" theme="shopping" />
</template>
